module.exports = __webpack_public_path__ + "img/overall-view-sp.e34c29e.png";